import { Component, Input, OnInit } from '@angular/core';
import { WorkflowRunService } from '@app/services/workflow-run.service';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';
import tourData from 'src/assets/api-dummy-data.json';
import { TourGuideService } from '@app/services/tour-guide.service';
import { Messages } from '@app/util/messages';
import { TourGuideContent } from '@app/util/tour-guide-content.util';
import { DatePipe } from '@angular/common';
import dummyData from '@app/assets/api-dummy-data.json';

@Component({
  selector: 'app-workflow-run-overview',
  templateUrl: './workflow-run-overview.component.html',
  styleUrls: ['./workflow-run-overview.component.scss']
})

export class WorkflowRunOverviewComponent implements OnInit {

  /****************** Variable declaration ******************/
  startDateTime: string;
  endDateTime: string;

  getNoData = Messages.no_data;
  tourId = TourGuideContent;
  /**tabs for table */
  tabs: any[] = [];
  wkflJobExctNm: any;
  wkflJobExctRslt: any;
  wkflJobExctDur: any;
  /** GANTT CHART DATA */
  startTime = "9:00";
  endTime = "11:00";
  data: any = null;

  /****************** Input and Output decorators ******************/
  @Input() rowData: any;
  @Input() stageDetails: any;

  /**
   * Constructor
   * @param workflowRunService
   * @param commonFunctionalitiesService
   * @param tourGuideService
   * @param cf
   * @param datePipe
   */
  constructor(private workflowRunService: WorkflowRunService,
    public commonFunctionalitiesService: CommonFunctionalitiesService,
    public tourGuideService: TourGuideService,
    private cf: CommonFunctionalitiesService,
    private datePipe: DatePipe) { }

  /** 
   * ngOnInit 
   * Api call when the component is initialized
   * If tour guide is initialized the api call's will be skipped
  */
  ngOnInit() {
    if (this.tourGuideService.isStartTour) {
      this.data = tourData.workflows.wfRun.runoverviewdata; //for the tourguide passing the dummy data for workflow table
      this.functionCall();
      return;
    }
    this.functionCall();
  }

  /**ngOnChanges */
  ngOnChanges() {
    this.functionCall();
  }

  /**multiple function calls at once */
  functionCall() {
    this.calculateTime();
    this.updateGanttChartData();
    this.getStepsDet();
  }

  /**
   * CalculateTime function is used to get the time from the whole date and time
   */
  calculateTime() {
    const triggeredOn = this.cf.getBrowserTime(this.rowData.triggeredOn)
    const startHour = triggeredOn.getHours();
    const startMinutes = triggeredOn.getMinutes();
    this.startDateTime = `${startHour}:${startMinutes}`;
    const duration = this.rowData.duration * 1000; // Convert duration to milliseconds
    const endTime = new Date(triggeredOn.getTime() + duration);
    const endHour = endTime.getHours();
    const endMinutes = endTime.getMinutes();
    this.endDateTime = `${endHour}:${endMinutes}`;
  }

  /**
   * UpdateGanttChartData function is used to update the start and end time of gantt chart
   */
  updateGanttChartData() {
    this.startTime = this.startDateTime;
    this.endTime = this.endDateTime;
  }

  /****************************Api calls *****************************/

  /**
   * getStepsDet function retrieves the jobs with info according to gantt chart
   */
  getStepsDet() {
    if(this.tourGuideService.isStartTour) {
      this.data = dummyData.workflows.wfRun.runoverviewdata;
      return;
    }
    this.workflowRunService.getWfJobDet(true, this.rowData.jobId).subscribe((response: any) => {
      let jobs = response?.data?.dbResp;
      jobs.map((j: any) => {
        j.start = this.datePipe.transform(this.cf.getBrowserTime(j.start), 'hh:mm:ss')
        j.end = this.datePipe.transform(this.cf.getBrowserTime(j.end), 'hh:mm:ss')
      })
      this.data = jobs;
    });
  }
}
